import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionRoute, type PermissionRouteData } from '@exam-center/router';

interface ProctoringDetailsPermissionRouteProps {
  examCenterCode: string;
  examEventId: string;
}

export default function ProctoringDetailsPermissionRoute(
  props: Readonly<ProctoringDetailsPermissionRouteProps>,
) {
  const { examCenterCode, examEventId } = props;

  const routes: PermissionRouteData[] = [
    {
      path: '/:examCenterCode/proctoring/exam-events/:examEventId/details',
      params: { examCenterCode, examEventId },
      requiredPermission: [APP_PERMISSIONS.PROCTORING.DETAILS.VIEW],
    },
    {
      path: '/:examCenterCode/proctoring/exam-events/:examEventId/registrations',
      params: { examCenterCode, examEventId },
      requiredPermission: [APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW],
    },
    {
      path: '/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc',
      params: { examCenterCode, examEventId },
      requiredPermission: [APP_PERMISSIONS.PROCTORING.E_KYC.VIEW],
    },
  ];

  return <PermissionRoute routes={routes} />;
}
